import type { AppApiClient, YadaService } from '@yada/types';
import { AUTH_API_URL, fetchWithAuth } from '@yada/api-client';

const SERVICE_URLS: Record<YadaService, string> = {
  auth: AUTH_API_URL,
};

/**
 * Resolves a service-relative path. Only paths under the service's own origin are
 * accepted, so an app cannot send the user's credentials elsewhere
 * ("//evil.example", "@evil.example", absolute URLs).
 */
export function resolveServiceUrl(service: YadaService, path: string): string {
  const base = SERVICE_URLS[service];
  if (!base) throw new Error(`Unknown YADA service: ${service}`);
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) {
    throw new Error(`Service paths start with a single "/": ${path}`);
  }
  const url = new URL(base.replace(/\/$/, '') + path);
  if (url.origin !== new URL(base).origin) throw new Error(`Path leaves the ${service} service: ${path}`);
  return url.toString();
}

/** host.api for every app: first-party calls with the shell's session handling. */
export function createServiceApi(): AppApiClient {
  return {
    fetch: async (service, path, init) => fetchWithAuth(resolveServiceUrl(service, path), init),
  };
}
